export class TokenExpiredNotification extends Error {
    
}